/* eslint complexity: ["error", 5], max-params: ["error", 3], max-depth: ["error", 2], max-statements: ["error", 10] */

'use strict';

const Accommodations = require('od-apps/app.accommodations');
const PARTNER_ID = 'partnerId=A4453E2E995D49988B6110EA6DA8EB4D';

const getTripAdvisorUrl = (tripAdvisorId, lang) => {
    return `//www.tripadvisor.com/WidgetEmbed-cdspropertydetail?locationId=${tripAdvisorId}&${PARTNER_ID}&display=true&lang=${lang}`;
};

function fetchDetails() {
    Odigeo.trigger('session:refreshed');
    this.trigger('fetchDetails');
    this.pending = true;

    return this.fetch({
        data: {key: this.get('key')},
        success: Odigeo._.bind(successFetch, this),
        error: Odigeo._.bind(errorFetch, this),
    });
}

function successFetch() {
    this.pending = false;
    mapImages.call(this);
    mapFacilities.call(this);
    this.trigger('loadDetails');
    Odigeo.trigger('accommodation-details-manager:loadDetails');
    return this;
}

function errorFetch(model, error) {
    reset.call(this);
    this.trigger('failLoad', error);
    Odigeo.trigger('accommodation-details-manager:failLoad');
}

function reset(attributes) {
    this.clear().set(Odigeo._.extend({}, this.defaults, attributes));
}

function reloadData(options) {
    this.trigger('loadDetails');
    if (options.isIPLightBox) {
        Odigeo.trigger(this.widget.id + ':reloadRooms');
    }
    return $.Deferred().resolve();
}

function mapImages() {
    Odigeo._.each(this.getImages(), function(image) {
        if (Odigeo._.isEmpty(image.thumbnailUrl)) {
            image.thumbnailUrl = image.url;
        }
        mapSecureImage.call(this, image);
    }, this);
}

function mapSecureImage(image) {
    if (Odigeo.Utils.getWebProtocol() === 'https:') {
        image.url = image.url.replace('http:', 'https:');
        image.thumbnailUrl = image.thumbnailUrl.replace('http:', 'https:');
    }
}

function mapFacilities() {
    this.set('groupFacilities', Accommodations.convertFacilities(getFacilities.call(this)));
}

function getFacilities() {
    return this.get('accommodationFacilities') || [];
}

function ensureTripAdvisorId(options) {
    const copy = {...options};
    if (Odigeo._.isString(copy.tripAdvisorId) && Odigeo._.isEmpty(copy.tripAdvisorId)) {
        copy.tripAdvisorId = null;
    }
    return copy;
}

var AccommodationDetailsModel = Odigeo.Model.extend({
    dataUrl: 'accommodation/details',
    pending: false,
    tracking: true,
    defaults: {
        key: null,
        tripAdvisorId: null,
        reviewsURL: function(tripAdvisorId, lang, reviewsProvider) {
            if (Odigeo.AB.isDynpackTrustYouReviews && reviewsProvider === 'TY') {
                return `https://api.trustyou.com/hotels/${tripAdvisorId}/meta_review.html?lang=${lang}`;
            }
            return getTripAdvisorUrl(tripAdvisorId, lang);
        },
        groupFacilities: {},
    },

    url: function() {
        return Odigeo.Settings.getProperty('serviceUrlFormatter')(this.dataUrl);
    },

    loadDetails(data) {
        this.set(data);
        this.trigger('loadDetails');
    },
    update: function(options) {
        const newOptions = ensureTripAdvisorId(options);
        const {forceUpdate = false} = newOptions;

        if (forceUpdate || this.get('key') !== newOptions.key) {
            reset.call(this, newOptions);
            return fetchDetails.call(this);
        } else {
            if (!this.pending) {
                return reloadData.call(this, newOptions);
            }
        }
        return $.Deferred().resolve();
    },

    deleteImgs: function(errorKeys) {
        if (!Odigeo._.isEmpty(errorKeys)) {
            this.set('accommodationImages', Odigeo._.reject(this.getImages(), function(value, key) {
                return Odigeo._.includes(errorKeys, key);
            }));
            this.trigger('remove:img');
        }

        return this;
    },

    getAccommodationDealInformation: function() {
        return this.get('accommodationDealInformation') || {};
    },

    getCoordinates: function() {
        return this.getAccommodationDealInformation().coordinates || {};
    },

    getImages: function() {
        return this.get('accommodationImages') || [];
    },

    getImage: function(index) {
        return this.getImages()[index] || {};
    },

    getImagesLength: function() {
        return this.getImages().length;
    },
});
var instance;

module.exports.AccommodationDetailsModel = AccommodationDetailsModel;
module.exports.getInstance = function() {
    if (Odigeo._.isUndefined(instance)) {
        instance = new AccommodationDetailsModel();
    }

    return instance;
};
